import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import AuthFooter from '../components/shared/AuthFooter/AuthFooter'
import ReceiveWallet from '../components/ReceiveWallet/ReceiveWallet'

import { copyTextFromDisplay } from '../components/shared/QbDisplay/QbDisplay'
import { WALLET_RECEIVE_ACTIONS } from '../store/actions/wallet'
import requireWallet from '../hoc/requireWallet'

class ReceiveWalletContainer extends Component {

  state = {
    showQr: false
  }

  componentWillUnmount() {
    this.props.resetWalletReceiveState()
  }

  handleShowQr = () => {
    this.setState({
      showQr: !this.state.showQr
    })
  }

  copyAddress = () => {
    const { walletAddress } = this.props
    copyTextFromDisplay(walletAddress)
    this.props.onCopyToClipboard()
  }

  render() {
    return (
      <div className="main-container main-container--flex-column">
        <ReceiveWallet
          {...this.props}
          {...this.state}
          handleShowQr={this.handleShowQr}
          copyAddress={this.copyAddress}
        />
        <AuthFooter />
      </div>
    )
  }
}

const mapStateToProps = ({ walletReducer }) => {
  const { walletProfile, receiveProfile } = walletReducer
  const { wallet } = walletProfile
  return {        
    walletAddress: wallet.address,
    copySuccessMsg: receiveProfile.copySuccessMsg
  }
}

const mapDispatchToProps = dispatch => 
  bindActionCreators({
    ...WALLET_RECEIVE_ACTIONS
  }, dispatch)

export default requireWallet(connect(mapStateToProps, mapDispatchToProps)(ReceiveWalletContainer))



// WEBPACK FOOTER //
// ./src/containers/ReceiveWalletContainer.js